import loginModel from './login';

export default {
    apiError: function(errorResponse, router) {
        let returnError = false;
        if (errorResponse.response) {
            if(errorResponse.response.data && errorResponse.response.data.reason) {
                returnError = errorResponse.response.data.reason;
            } else if (errorResponse.response.data && errorResponse.response.data.message) {
                if (errorResponse.response.data.message === "Unauthenticated.") {
                    loginModel.logout(router);
                }

                returnError = 'Error: ' + errorResponse.response.data.message;
            }
        } else {
            returnError = errorResponse.toString();
        }

        return returnError;
    },

};
